// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"Arrow_Arrow__ATZ17","down":"Arrow_down__3tM2u","bob-down":"Arrow_bob-down__38Sp4","up":"Arrow_up__1Kypb","bob-up":"Arrow_bob-up__1zLgz"};